import { render, staticRenderFns } from "./ProjectSharePopover.vue?vue&type=template&id=15c64e97&scoped=true&"
import script from "./ProjectSharePopover.vue?vue&type=script&lang=ts&"
export * from "./ProjectSharePopover.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSharePopover.vue?vue&type=style&index=0&id=15c64e97&prod&lang=scss&scoped=true&"
import style1 from "./ProjectSharePopover.vue?vue&type=style&index=1&id=15c64e97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c64e97",
  null
  
)

export default component.exports